"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAuth = exports.mockReportError = exports.AuthProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _client = require("@apollo/client");
var _auth = require("../lib/auth");
var _user = require("../lib/graphql/queries/user");
var _string = require("../utils/string");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var AuthContext = /*#__PURE__*/(0, _react.createContext)(null);
var mockReportError = (_err, _options) => {};
exports.mockReportError = mockReportError;
var AuthProvider = _ref => {
  var {
    children,
    reportError,
    authEndpoint,
    userQuery = _user.MY_USER
  } = _ref;
  var [user, setUser] = (0, _react.useState)(null);
  var [lastAuthenticated, setLastAuthenticated] = (0, _react.useState)(null);
  var client = (0, _client.useApolloClient)();
  (0, _react.useEffect)(() => {
    hydrateUser(false);
  }, []);
  var hydrateUser = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* () {
      var useCache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var operation = 'isAuthenticated';
      var user = null;
      try {
        var hasCurrentUser = yield (0, _auth.isAuthenticated)(authEndpoint);
        if (hasCurrentUser) {
          operation = 'query myUser';
          var {
            data
          } = yield client.query({
            query: userQuery,
            fetchPolicy: useCache ? 'cache-first' : 'network-only'
          });
          user = data.myUser;
          if (data.userPermissions) {
            user = _objectSpread(_objectSpread({}, data.myUser), {}, {
              permissions: data.userPermissions
            });
          }
          setUser(user);
        }
      } catch (err) {
        reportError(err, {
          metaData: {
            operation
          }
        });
      } finally {
        setLastAuthenticated(new Date());
        return user;
      }
    });
    return function hydrateUser() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react.default.createElement(AuthContext.Provider, {
    value: {
      currentUser: user,
      hydrateUser,
      lastAuthenticated
    }
  }, children);
};
exports.AuthProvider = AuthProvider;
var useAuth = exports.useAuth = function useAuth() {
  var useCache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var {
    currentUser,
    hydrateUser,
    lastAuthenticated
  } = (0, _react.useContext)(AuthContext);
  (0, _react.useEffect)(() => {
    hydrateUser(useCache);
  }, []);
  var permissions = currentUser && currentUser.permissions ? currentUser.permissions : [];
  var permissionsMap = (0, _react.useMemo)(() => {
    return permissions.reduce((prev, current) => {
      var type = (0, _string.regularToCamelCase)(current.type);
      if (!prev[type]) prev[type] = {
        access: false
      };
      prev[type].access = current.access || prev[type].access;
      prev[type][current.operationName] = current.access;
      return prev;
    }, {});
  }, [permissions]);
  var isTeamMember = () => {
    return currentUser ? ['Admin', 'Team'].includes(currentUser.permissionGroup.groupName) : false;
  };
  return {
    currentUser,
    hydrateUser,
    lastAuth: lastAuthenticated,
    isTeamMember,
    permissionsMap
  };
};